"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationTransportCreate = exports.ObjectReferenceCreate = exports.CommunicationTemplateTransport = exports.CommunicationTransport = exports.ObjectReference = exports.DestinationTransport = exports.ObjectType = exports.ObjectTypes = exports.AnyCommunicationType = exports.isMandatoryCommunicationType = exports.MandatoryCommunicationType = exports.MandatoryCommunicationTypes = exports.CommunicationType = exports.CommunicationTypesLabels = exports.CommunicationTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.CommunicationTypes = [
    //these don't exist yet
    // 'SUBSCRIPTION_PAUSE',
    // 'SUBSCRIPTION_CANCEL',
    // 'SUBSCRIPTION_PAUSE_REMINDER',
    // 'SUBSCRIPTION_RESUME_REMINDER',
    // 'SUBSCRIPTION_CONFIRMATION',
    'ROLL_OFF_ORDER_CONFIRMATION',
    'OPERATIONS_ROLL_OFF_ORDER_CONFIRMATION',
    // 'ROLL_OFF_ORDER_UPDATE',
    'ROLL_OFF_NEW_ORDER_HAULER_ALERT',
    'ROLL_OFF_ORDER_CANCEL',
    'ROLL_OFF_DRIVER_ENROUTE',
    'WAYSTE_AUTOPAY_RECEIPT',
    'ROLL_OFF_DAY_BEFORE_SERVICE_REMINDER',
    'ROLL_OFF_DAY_OF_SERVICE_REMINDER',
    'ROLLOFF_INVOICE_PAYMENT',
    'WAYSTE_INVOICE_ISSUE_RECEIPT',
    'WAYSTE_AUTOPAY_FAILURE',
    'WAYSTE_INVOICE_PAYMENT_RECEIPT',
    'SUBSCRIPTION_INVOICE_CREATED',
    'SUBSCRIPTION_INVOICE_PAYMENT_RECEIPT',
];
exports.CommunicationTypesLabels = {
    ROLL_OFF_ORDER_CONFIRMATION: 'Order Confirmation & Service Agreement',
    OPERATIONS_ROLL_OFF_ORDER_CONFIRMATION: 'Order Confirmation & Service Agreement',
    ROLL_OFF_NEW_ORDER_HAULER_ALERT: 'New Order Alert (Hauler)',
    ROLL_OFF_ORDER_CANCEL: 'Order Cancellation',
    ROLL_OFF_DRIVER_ENROUTE: 'Driver on the Way',
    WAYSTE_AUTOPAY_RECEIPT: 'Autopay Receipt',
    ROLL_OFF_DAY_BEFORE_SERVICE_REMINDER: 'Day Before Service Reminder',
    ROLL_OFF_DAY_OF_SERVICE_REMINDER: 'Day of Service Reminder',
    ROLLOFF_INVOICE_PAYMENT: 'Order Invoice Payment',
    WAYSTE_INVOICE_ISSUE_RECEIPT: 'Subscription Invoice',
    WAYSTE_AUTOPAY_FAILURE: 'Autopay Failed',
    WAYSTE_INVOICE_PAYMENT_RECEIPT: 'Subscription Invoice Receipt',
    SUBSCRIPTION_INVOICE_CREATED: 'Portable Toilet Invoice',
    SUBSCRIPTION_INVOICE_PAYMENT_RECEIPT: 'Portable Toilet Invoice Receipt',
};
exports.CommunicationType = typebox_1.Type.Union(exports.CommunicationTypes.map((communicationType) => typebox_1.Type.Literal(communicationType)));
// Communication types that cannot be disabled for any user.
exports.MandatoryCommunicationTypes = [
    'AUTH_PASSWORD_RESET',
    'AUTH_PASSWORD_RESET_CODE',
    'AUTH_VERIFY_EMAIL',
    'AUTH_VERIFY_EMAIL_CODE',
    'AUTH_BLOCKED_ACCOUNT',
    'AUTH_STOLEN_CREDENTIALS',
    'AUTH_MFA_ENROLLMENT',
    'AUTH_MFA_CODE',
    'AUTH_USER_INVITATION',
    'AUTH_OTP_CODE',
    'AUTH_PASSWORD_BREACH',
    'PAYMENT_PROCESSING_CHARGEBACK_ACTION_REQUIRED',
    'PAYMENT_PROCESSING_CHARGEBACK_LOST',
    'PAYMENT_PROCESSING_CHARGEBACK_WON',
    'PAYMENT_PROCESSING_APPLICATION_NEEDS_INFORMATION',
    'PAYMENT_PROCESSING_APPLICATION_DECLINED',
    'PAYMENT_PROCESSING_APPLICATION_COMPLETED',
    'PAYMENT_PROCESSING_MERCHANT_SUSPENDED',
    'PAYMENT_PROCESSING_MERCHANT_DEACTIVATED',
    'PAYMENT_PROCESSING_ACH_RETURN_CREATED',
    'PAYMENT_PROCESSING_ACH_PAYIN_FAILED',
];
exports.MandatoryCommunicationType = typebox_1.Type.Union(exports.MandatoryCommunicationTypes.map((communicationType) => typebox_1.Type.Literal(communicationType)));
const MANDATORY_COMMUNICATION_TYPE_SET = new Set(exports.MandatoryCommunicationTypes);
/** Narrows an AnyCommunicationType to the mandatory (auth) subset. */
const isMandatoryCommunicationType = (type) => MANDATORY_COMMUNICATION_TYPE_SET.has(type);
exports.isMandatoryCommunicationType = isMandatoryCommunicationType;
/** Either a preference-eligible communication or a mandatory auth communication. Used where a
 * communication_template can hold either kind (storage + lookup). */
exports.AnyCommunicationType = typebox_1.Type.Union([exports.CommunicationType, exports.MandatoryCommunicationType]);
//NB these are the DB table names, as they are more meaningful than the actual object types
exports.ObjectTypes = [
    'Orders', //roll off order
    'commercial_subscription', // wayste-commercial-subscription
    'operations_subscription', // operations-subscription
    'WaysteReceivables', //invoice
    'Recievables', // unified billing (v2) receivable
    'billing_activity', // wayste-commercial-subscription billing activity
    'operations_billing_period', // operations-subscription billing period ID
    'operations_order_ro', // operations-service roll-off order
];
exports.ObjectType = typebox_1.Type.Union(exports.ObjectTypes.map((type) => typebox_1.Type.Literal(type)));
exports.DestinationTransport = typebox_1.Type.Object({
    email: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
    sms: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
    usePreferences: typebox_1.Type.Optional(typebox_1.Type.Boolean({ default: false })),
    communicationType: typebox_1.Type.Optional(exports.CommunicationType),
});
exports.ObjectReference = typebox_1.Type.Object({
    id: typebox_1.Type.String({
        format: 'uuid',
    }),
    objectID: typebox_1.Type.String(),
    type: exports.ObjectType,
});
exports.CommunicationTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({
        format: 'uuid',
    }),
    haulerID: typebox_1.Type.String({
        format: 'uuid',
    }),
    customerID: typebox_1.Type.String({
        format: 'uuid',
    }),
    communicationType: exports.AnyCommunicationType,
    destination: exports.DestinationTransport,
    sendTime: typebox_1.Type.Optional(typebox_1.Type.String({
        format: 'date-time',
    })),
    objectReferences: typebox_1.Type.Optional(typebox_1.Type.Array(exports.ObjectReference)),
});
exports.CommunicationTemplateTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({
        format: 'uuid',
        description: 'This is ignored on update and create',
    }),
    haulerId: typebox_1.Type.String({
        format: 'uuid',
        description: 'This is ignored on update and create',
    }),
    type: exports.AnyCommunicationType,
    template: typebox_1.Type.String(),
    destinationType: typebox_1.Type.Union([typebox_1.Type.Literal('sms'), typebox_1.Type.Literal('email')]),
    subject: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.ObjectReferenceCreate = typebox_1.Type.Omit(exports.ObjectReference, ['id']);
exports.CommunicationTransportCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CommunicationTransport, ['id', 'objectReferences']),
    typebox_1.Type.Object({
        objectReferences: typebox_1.Type.Array(exports.ObjectReferenceCreate),
        customMessage: typebox_1.Type.Optional(typebox_1.Type.String()),
        deliveryInstructions: typebox_1.Type.Optional(typebox_1.Type.String()),
        senderName: typebox_1.Type.Optional(typebox_1.Type.String()),
        /** Order total in cents, rendered as a dollar amount */
        orderTotalCents: typebox_1.Type.Optional(typebox_1.Type.Number()),
        /** The complete prohibited-items paragraph for this order's material and pricing zone */
        prohibitedItemsNotice: typebox_1.Type.Optional(typebox_1.Type.String()),
        /** The comma-joined prohibited-items list for this order's pricing zone */
        prohibitedItemsList: typebox_1.Type.Optional(typebox_1.Type.String()),
        // Documents attached to the email channel by reference and fetched at send time.
        // RECEIVABLE_PDF: objectID is a unified receivable ("Recievables") whose invoice PDF is
        // attached. The type union widens as new attachment sources are needed.
        attachmentReferences: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Object({
            type: typebox_1.Type.Literal('RECEIVABLE_PDF'),
            objectID: typebox_1.Type.String(),
        }))),
    }),
]);
//# sourceMappingURL=communication.js.map